// extracted by mini-css-extract-plugin
export default {"sortIconBlock":"misc_sortIconBlock__bvdxa"};